import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../global/environmentVariables";
import { globalVariables } from "../global/GlobalVariables";
import AffiliateLanding from "../pages/affiliates/AffiliateLanding";
import StripeSessionConfirmation from "../pages/stripe/StripeSessionConfirmation";
import Subscription from "../pages/subscription/Subscription";
import SubscriptionCheckout from "../pages/subscription/SubscriptionCheckout";
import SubscriptionComplete from "../pages/subscription/SubscriptionComplete";
import SubscriptionTrial from "../pages/subscription/SubscriptionTrial";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import ComingSoonPage from "../pages/utility/ComingSoonPage";
import NotFound from "../pages/utility/NotFound";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";
const NO_SUBSCRIPTIONS = getEnvironmentVariable("NO_SUBSCRIPTIONS") === "true";
const IS_PRIMAL = getEnvironmentVariable("IS_PRIMAL") === "true";

export const subscriptionRoutes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  const forceLoginParam = findGetParameter("forceLogin");
  const globalVars = globalVariables();

  return [
    {
      path: "subscription",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "organization/new",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <SubscriptionCheckout subscriptionType="StoreSubscription" />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "new",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <SubscriptionCheckout subscriptionType="Subscription" />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "session-status",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <StripeSessionConfirmation />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: ":subscriptionId",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            authContext?.authState?.isAuthenticated ? (
              <SubscriptionComplete />
            ) : (
              <LoginRedirect />
            )
          ) : (
            <NotFound />
          )
        },
        {
          path: "circuit-suite",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : globalVars.pricing.subscriptions.circuitSuite ? (
            <Subscription hidePlayerSubs />
          ) : (
            <NotFound />
          )
        },
        {
          path: "player",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : globalVars.pricing.subscriptions.playerSub ? (
            <Subscription hideCircuitSuite />
          ) : (
            <NotFound />
          )
        },
        {
          path: "/subscription/",
          element: IS_PRIMAL ? (
            <ComingSoonPage />
          ) : !NO_SUBSCRIPTIONS ? (
            <Subscription />
          ) : (
            <NotFound />
          )
        }
      ]
    }
  ];
};

export const rootSubscriptionRoutes = () => {
  return [
    {
      path: "tacomatrial",
      element: IS_BCP ? <SubscriptionTrial path="tacomatrial" /> : <NotFound />
    },
    {
      path: "wcw25",
      element: IS_BCP ? <AffiliateLanding affiliate="wcw25" /> : <NotFound />
    },
    {
      path: "wtc25",
      element: IS_BCP ? <AffiliateLanding affiliate="wtc25" /> : <NotFound />
    },
    {
      path: "tabletoptitans",
      element: IS_BCP ? (
        <AffiliateLanding affiliate="tabletoptitans" />
      ) : (
        <NotFound />
      )
    },
    {
      path: "titans",
      element: IS_BCP ? <AffiliateLanding affiliate="titans" /> : <NotFound />
    },
    {
      path: "artofwar-subscription",
      element: IS_BCP ? (
        <Subscription
          affiliate="artofwar"
          affiliateLabel="The Art of War affiliate"
        />
      ) : (
        <NotFound />
      )
    },
    {
      path: "flgaus-subscription",
      element: IS_BCP ? <Subscription affiliate="flgAUS" /> : <NotFound />
    },
    {
      path: "nova-subscription",
      element: IS_BCP ? <Subscription affiliate="nova" /> : <NotFound />
    },
    {
      path: "flg-subscription",
      element: IS_BCP ? <Subscription affiliate="flg" /> : <NotFound />
    },
    {
      path: "tak-games",
      element: IS_BCP ? <Subscription affiliate="takgames" /> : <NotFound />
    },
    {
      path: "tacomasale",
      element: IS_BCP ? (
        <AffiliateLanding
          affiliate="TACOMA25"
          frequencies={{
            Yearly: {
              couponCode: "TACOMA25",
              discount: { percentage: 0.2 }
            }
          }}
          couponCode={{
            code: "TACOMA25",
            discount: { percentage: 0.2, onceOff: true },
            frequencies: { Yearly: true }
          }}
        />
      ) : (
        <NotFound />
      )
    },
    {
      path: "spikeybits",
      element: IS_BCP ? (
        <Subscription
          affiliate="spikeybits"
          frequencies={{
            Yearly: {
              couponCode: "SAVER20",
              discount: { percentage: 0.2 }
            }
          }}
          couponCode={{
            code: "SAVER20",
            discount: { percentage: 0.2, onceOff: true },
            frequencies: { Yearly: true }
          }}
        />
      ) : (
        <NotFound />
      )
    }
  ];
};
